import { render } from "./LocationSelect.vue?vue&type=template&id=6f05f2dc"
import script from "./LocationSelect.vue?vue&type=script&lang=js"
export * from "./LocationSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__